var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, GBTypography, TextInput } from '@leapfinance/geebee-component-library';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { BOOKMARK_ACTION_TYPES } from '../../../constants/common';
import { convertToNormalCase } from '../../../helpers';
import { MAX_BOOKMARK_TITLE_LENGTH, MIN_BOOKMARK_TITLE_LENGTH } from '../constants';
var ITEM_HEIGHT = 48;
var BookmarkCard = function (_a) {
    var id = _a.id, title = _a.title, coursesAddedCount = _a.coursesAddedCount, _b = _a.countries, countries = _b === void 0 ? [] : _b, _c = _a.intakes, intakes = _c === void 0 ? [] : _c, description = _a.description, renderTruncatedList = _a.renderTruncatedList, _d = _a.actionsAllowed, actionsAllowed = _d === void 0 ? [
        BOOKMARK_ACTION_TYPES.ARCHIVE,
        BOOKMARK_ACTION_TYPES.DUPLICATE,
        BOOKMARK_ACTION_TYPES.RENAME,
        BOOKMARK_ACTION_TYPES.UNARCHIVE
    ] : _d, _e = _a.isArchiveMode, isArchiveMode = _e === void 0 ? false : _e, _f = _a.containerStyles, containerStyles = _f === void 0 ? {
        minWidth: '5rem'
    } : _f, titleElement = _a.titleElement, studentProfile = _a.studentProfile, onClick = _a.onClick, onRename = _a.onRename, onDuplicate = _a.onDuplicate, onArchive = _a.onArchive, onUnArchive = _a.onUnArchive;
    var _g = __read(useState(false), 2), isRenameMode = _g[0], setIsRenameMode = _g[1];
    var _h = __read(useState(title), 2), updatedTitleText = _h[0], setUpdatedTitleText = _h[1];
    var _j = __read(useState(null), 2), anchorEl = _j[0], setAnchorEl = _j[1];
    var handleClick = function (event) {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function (event) {
        event.stopPropagation();
        setAnchorEl(null);
    };
    var handleRenameBookmark = function (event) {
        event.stopPropagation();
        setIsRenameMode(false);
        onRename === null || onRename === void 0 ? void 0 : onRename({
            updatedTitleText: updatedTitleText,
            id: id
        });
    };
    return (React.createElement(Box, { className: "lfc-bg-white lfc-flex lfc-items-center lfc-justify-between lfc-py-4 lfc-px-3 lfc-rounded-lg lfc-border-primary-500 lfc-border hover:lfc-bg-primary-150 lfc-cursor-pointer", sx: containerStyles, id: "bookmark-".concat(id), onClick: function (e) {
            onClick === null || onClick === void 0 ? void 0 : onClick({
                id: id
            });
        } },
        React.createElement("div", { className: "lfc-flex lfc-flex-col" },
            React.createElement("p", { className: "lfc-text-gray-1301 lfc-text-base lfc-font-semibold lfc-mb-1 lfc-flex lfc-items-center" },
                isRenameMode ? (React.createElement(FormControl, null,
                    React.createElement(TextInput, { value: updatedTitleText, onChange: function (event) {
                            setUpdatedTitleText(event.target.value);
                        }, sx: {
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '0.5rem',
                                height: '2.5rem'
                            }
                        }, onClick: function (event) {
                            event.stopPropagation();
                        } }),
                    updatedTitleText.length === MIN_BOOKMARK_TITLE_LENGTH && (React.createElement(FormHelperText, { error: true }, "Title cannot be empty")),
                    updatedTitleText.length > MAX_BOOKMARK_TITLE_LENGTH && (React.createElement(FormHelperText, { error: true }, "Title cannot be more than 255 characters")))) : (React.createElement("div", { className: "lfc-break-all" },
                    React.createElement(GBTypography, { variant: "body3" }, titleElement))),
                actionsAllowed.includes(BOOKMARK_ACTION_TYPES.RENAME) ? (React.createElement("span", null, isRenameMode ? (React.createElement("div", { className: "lfc-flex lfc-items-center" },
                    React.createElement(IconButton, { disabled: updatedTitleText.length === 0, onClick: handleRenameBookmark },
                        React.createElement(SaveAsOutlinedIcon, null)),
                    React.createElement(IconButton, { onClick: function (event) {
                            event.stopPropagation();
                            setUpdatedTitleText(title);
                            setIsRenameMode(false);
                        } },
                        React.createElement(ClearOutlinedIcon, null)))) : (React.createElement(IconButton, { onClick: function (event) {
                        event.stopPropagation();
                        setIsRenameMode(true);
                    } },
                    React.createElement(ModeEditOutlinedIcon, null))))) : null),
            description ? (React.createElement("p", { className: "lfc-mr-1 lfc-text-gray-850 lfc-mb-2 lfc-break-all" },
                React.createElement(GBTypography, { variant: "caption1" }, description))) : null,
            renderTruncatedList),
        React.createElement("div", { className: "lfc-self-start" }, isArchiveMode ? (React.createElement(Button, { variant: "secondary", onClick: function (event) {
                event.stopPropagation();
                onUnArchive === null || onUnArchive === void 0 ? void 0 : onUnArchive({
                    id: id
                });
            } }, "Unarchive")) : (React.createElement("div", null, actionsAllowed.length > 0 ? (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", onClick: handleClick },
                React.createElement(MoreVertOutlinedIcon, null)),
            React.createElement(Menu, { id: "long-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, PaperProps: {
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch'
                    }
                } },
                actionsAllowed.includes(BOOKMARK_ACTION_TYPES.DUPLICATE) ? (React.createElement(MenuItem, { key: BOOKMARK_ACTION_TYPES.DUPLICATE, onClick: function (event) {
                        event.stopPropagation();
                        onDuplicate === null || onDuplicate === void 0 ? void 0 : onDuplicate({
                            id: id,
                            title: "Copy of ".concat(title),
                            countries: countries,
                            intakes: intakes,
                            description: description,
                            studentProfile: studentProfile
                        });
                        handleClose(event);
                    } },
                    React.createElement(GBTypography, { variant: "body4" }, convertToNormalCase(BOOKMARK_ACTION_TYPES.DUPLICATE)))) : null,
                actionsAllowed.includes(BOOKMARK_ACTION_TYPES.ARCHIVE) ? (React.createElement(MenuItem, { key: BOOKMARK_ACTION_TYPES.ARCHIVE, onClick: function (event) {
                        event.stopPropagation();
                        onArchive === null || onArchive === void 0 ? void 0 : onArchive({
                            id: id
                        });
                        handleClose(event);
                    } },
                    React.createElement(GBTypography, { variant: "body4" }, convertToNormalCase(BOOKMARK_ACTION_TYPES.ARCHIVE)))) : null))) : null)))));
};
export default BookmarkCard;
//# sourceMappingURL=BookmarkCard.js.map